export const fileUploadProps = {
  maxFileCount: 1,
  defaultSheetStatus: "Pending",
  fileUploadSuccessMessage: "Upload Completed!",
  signatureType: "signature",
  pngFileType: "image/png",
  PROGRESS_COLOR: "#87d068",
};
